// extracted by mini-css-extract-plugin
export default {"text":"empty-incart_text__GKzTd"};